import { render, staticRenderFns } from "./VideoQuestionManager.vue?vue&type=template&id=5c74e137&scoped=true"
import script from "./VideoQuestionManager.vue?vue&type=script&lang=js"
export * from "./VideoQuestionManager.vue?vue&type=script&lang=js"
import style0 from "./VideoQuestionManager.vue?vue&type=style&index=0&id=5c74e137&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c74e137",
  null
  
)

export default component.exports